import Vue from "vue";
import VueRouter from "vue-router";
import routes from "./routes";
import store from "../store";

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
  mode: "history",
  linkActiveClass: "active",
  linkExactActiveClass: "active",
  base: process.env.VUE_APP_BASE_URL,
});

router.afterEach(async () => {
  // busca o objeto keycloak da store
  const keycloak = store.getters.keycloak;
  // verifica se existe um erro na URL (ex: erro de login)
  const hash = window.location.hash.substring(1);
  const params = new URLSearchParams(hash);
  const error = params.get("error");

  // se houver erro, marca que a checagem já foi executada
  if (error) {
    sessionStorage.setItem("checagemExecutada", "true");
  }

  // verifica se a checagem já foi executada nesta sessão
  const sessionChecagemExecutada = sessionStorage.getItem("checagemExecutada");

  try {
    // se a checagem já foi executada, ou se houve erro, ou se já está autenticado, não faz nada
    if (sessionChecagemExecutada || error || keycloak.authenticated) {
      return;
    }
    // define a URL para redirecionamento silencioso
    const silentCheckSsoRedirectUri = 
      `${window.location.protocol}//${window.location.host}${process.env.VUE_APP_BASE_URL}silent-check-sso.html`;

    const usuarioConectado = await keycloak.init({
      onLoad: "check-sso",
      silentCheckSsoRedirectUri,
      promiseType: "native",
    });
    
    // se não houver usuário conectado, não faz nada
    if (!usuarioConectado) {
      return;
    }

    await keycloak.init({
      onLoad: "login-required",
      promiseType: "native",
    });
  } catch (err) {
    console.error("Erro ao inicializar Keycloak:", err);
  } finally {
    // se houver erro na URL, limpa o hash para evitar loops de erro
    if (error) {
      router.replace({ path: router.currentRoute.path, query: {} });
    }
  }
});

router.beforeEach(async (to, from, next) => {
  const nomesRotasBloqueadas = ['403', '404', 'suspenso'];
  if (nomesRotasBloqueadas.includes(to.name)) {
    next(true);
    return;
  }
  
  const exigeLogin = to.matched.some((record) => record.meta.requiresAuth);

  if (!exigeLogin) {
    next(true);
    return;
  }

  next(true);
});

export default router;
